import { render } from "./SeoServicePage.vue?vue&type=template&id=75b777b5&scoped=true"
import script from "./SeoServicePage.vue?vue&type=script&lang=js"
export * from "./SeoServicePage.vue?vue&type=script&lang=js"

import "./SeoServicePage.vue?vue&type=style&index=0&id=75b777b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b777b5"]])

export default __exports__